export class sendOtpDto{
    mobileNumber?: number;
    phoneCode?: any;
    otp?: any;
    email?: string;
    sendOtpWithEmail?: boolean;
}
